import { useState } from "react";
import { useForm } from "react-hook-form";
import {NotificationContainer, NotificationManager} from 'react-notifications';

const Login = ({setAuth})=>{
    const [error,setError] = useState()
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = data =>{
      fetch('https://ibidaz.com/inventory/phpfiles/login.php',{
        method:'POST',
        body: JSON.stringify(data)
      })
      .then(res=>res.json())
      .then(user=>{
        if(user?.error){
            NotificationManager.error('Invalid username or password', "Error");
        }else if(user?.token){
            console.log(user.token)
           window.localStorage.setItem('token',user.token)
           window.localStorage.setItem('user',JSON.stringify(user))
           setAuth(true)
        }
      })
    } 
    // headers: {
    //     'Authorization': `Bearer ${store.JWT}`
    //   }
    return (
        <div className="container">
          <NotificationContainer/>
          <form onSubmit={handleSubmit(onSubmit)} className="login">
            <h1>Sign In</h1>
            {error && 
             <p style={{color:'tomato'}}>{error}</p>
            }
          <div className="input">
            <input
               type='text'
               style={{border:`${errors.user?'1px solid tomato':''}`}}
               {...register("user", { required: true })}
            />
           </div>
           <div className="input">
            <input
            style={{border:`${errors.pass?'1px solid tomato':''}`}}
            {...register("pass", { required: true })}
              type='password'
            />
           </div>
           <div className="input">
            <input type='submit' className="btn"
            style={{width:'100%'}} value='Login'/>
           </div>
          </form>
        </div>
    )
}

export default Login